var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "row no-gutters" }, [
      _c(
        "div",
        {
          staticClass: "col-auto",
          staticStyle: { "min-width": "200px", "text-align": "center" }
        },
        [
          _c("img", {
            staticClass: "img-fluid",
            staticStyle: { "max-width": "200px" },
            attrs: { src: _vm.parseLogo(_vm.entidad.logo_empresa), alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col",
          style: { width: "100%", background: _vm.parsedBack }
        },
        [
          _c("div", { staticClass: "card-block px-2" }, [
            _c("h4", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_vm.entidad.nombre_entidad))
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "card-text" },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c("p", { staticClass: "card-text" }, [
                        _c("strong", [_vm._v("CIF:")]),
                        _vm._v(" " + _vm._s(_vm.entidad.cif) + ", "),
                        _c("strong", [_vm._v("SAP:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.entidad.codigo_entidad) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "card-text" },
                        [
                          _vm.entidad.email_principal
                            ? [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" + _vm.entidad.email_principal,
                                      target: "_top"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.entidad.email_principal))]
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                            Sin correo electrónico\n                          "
                                )
                              ]
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { disabled: _vm.entidad.website === null },
                            on: { click: _vm.openWeb }
                          },
                          [_vm._v("Visitar web")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.goToDetails }
                          },
                          [_vm._v("Ver detalles")]
                        ),
                        _vm._v(" "),
                        !_vm.entidad.disabled
                          ? [
                              !_vm.selected
                                ? _c(
                                    "b-button",
                                    { on: { click: _vm.select } },
                                    [_vm._v("Seleccionar")]
                                  )
                                : _c(
                                    "b-button",
                                    { on: { click: _vm.deselect } },
                                    [_vm._v("Deseleccionar")]
                                  )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/EntidadSlot.vue?vue&type=template&id=f6e72cc2&
// module id = null
// module chunks = 